// @flow

import ajax from 'services/ajax/ajax';
import type { MapSuccess, MapFailure, SubmitVirtualEventResultPayload } from 'type/type';

export const createFromVirtualEvent = (
  {
    eventId,
    externalRouteId,
    registrationNumber,
    ...rest
  }: SubmitVirtualEventResultPayload,
  mapSuccess: MapSuccess,
  mapFailure?: MapFailure,
) => ajax.post({
  headers: {
    'Content-Type': 'application/vnd.active.results-service.v1+json',
  },
  url: `/results/events/${eventId}/route/${externalRouteId}/participants/${registrationNumber}`,
  body: JSON.stringify(rest),
}, { mapSuccess, mapFailure });
